import { LoadingOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { translate } from "../../locale";
import CompanyServices from "../../services/CompanyServices";
import UserServices from "../../services/UserServices";

const SimpleValidatorElement = (message) => (
  <div className="text-red-600 pt-2 text-xs">{message}</div>
);

const InviteUser = ({
  subscriptionId,
  visible,
  rol = "",
  enterpriseId,
  onComplete,
  onCancel,
}) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [values, setValues] = useState({
    subscription_id: subscriptionId,
    email: "",
    app: "eira",
    force: false,
  });
  const [title, setTitle] = useState("Invitar usuario");
  const [subscriptions, setSubscriptions] = useState([]);
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();
  const [acceptButtonText, setAcceptButtonText] = useState("Enviar");
  const refSubmitButton = useRef();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: SimpleValidatorElement,
      messages: {
        required: "Campo requerido",
        email: "El email no es válido",
      },
    })
  );

  useEffect(() => {
    let title = "";
    switch (rol) {
      case "professional":
        title = "Invitar profesional";
        break;
      case "company-admin":
        title = "Invitar Administrador de empresa";
        break;
      case "company-coordinator":
        title = "Invitar Coordinador de empresa";
        break;
      default:
        title = "Invitar usuario";
        break;
    }
    setTitle(title);
  }, []);

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);

      if (visible === true) {
        setValues({
          subscription_id: subscriptionId,
          email: "",
          app: "eira",
        });
        if (
          rol === "company-admin" ||
          (rol === "professional" && !subscriptionId)
        ) {
          console.log("visible", "company");
          getSubscriptions();
        }
      }
    }
  }, [visible]);

  const disabled = () => !simpleValidator.current.allValid();

  const getSubscriptions = async () => {
    try {
      setLoading(true);
      const response = await CompanyServices.getSubscriptions(enterpriseId);
      if (response.status >= 200 && response.status < 300) {
        setSubscriptions(
          response.data.subscriptions.map((i) => ({
            value: i.id,
            label: i.name,
          }))
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onFinish = async () => {
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("El email ingresado no es válido");
      return;
    }
    try {
      const data = {
        email: values.email,
        subscription: values.subscription_id,
        type: "email",
        rol: rol, // [patient | professional | company-admin]
        app: values.app,
        force: values.force,
      };

      const res = await UserServices.sendInvitation(data);

      if (res.data.message === "Mail Sent") {
        message.success(
          translate("La {0} se envió exitosamente.", translate("invitación"))
        );
        resetForm();
        if (onComplete) {
          onComplete();
        }
      } else {
        refSubmitButton.current.blur();
        let rsMessage = res.data.message;
        if (rsMessage === "Usuario con suscripción activa existente") {
          rsMessage +=
            ".\nSi continúa, se dará de baja al usuario de la suscripción actual.";
          setAcceptButtonText("Continuar");
          setValues((v) => ({ ...v, force: true }));
          setError(rsMessage);
        } else {
          message.success(rsMessage);
          resetForm();
          if (onComplete) {
            onComplete(true);
          }
        }
      }
      setLoading(false);
      setLoading(false);
    } catch (error) {
      console.log("onFinish error:", error);
      setLoading(false);
      setError(error.message);
    }
  };

  const resetForm = () => {
    setValues({
      email: "",
      force: false,
    });
    setAcceptButtonText("Enviar");
    setError("");
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <Modal
      open={active}
      title={title}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      <Form onFinish={onFinish} autoComplete="off" className="w-full">
        {(rol === "company-admin" ||
          (rol === "professional" && !subscriptionId)) && (
          <Form.Item>
            <Select
              name="subscription_id"
              onChange={(value) => {
                setValues((v) => ({ ...v, subscription_id: value }));
              }}
              value={values.subscription_id}
            >
              <Select.Option value="">
                {translate("Seleccione suscripción")}
              </Select.Option>
              {subscriptions.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
            {subscriptions.length > 0 &&
              simpleValidator.current.message(
                "subscription_id",
                values.subscription_id,
                "required"
              )}
          </Form.Item>
        )}
        <Form.Item>
          <Input
            placeholder="E-mail usuario"
            className="border-custom_primary"
            name="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          {simpleValidator.current.message(
            "email",
            values.email,
            "required|email"
          )}
        </Form.Item>
        <Form.Item>
          <Row align="end" gutter={16}>
            <Col>
              <Button key="back" onClick={handleCancel}>
                Cancelar
              </Button>
            </Col>
            <Col>
              <Button
                disabled={disabled()}
                htmlType="submit"
                type="primary"
                className="bg-custom_primary"
                ref={refSubmitButton}
              >
                {loading ? (
                  <Spin
                    indicator={<LoadingOutlined style={{ color: "#666666" }} />}
                  />
                ) : (
                  acceptButtonText
                )}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

InviteUser.propTypes = {
  subscriptionId: PropTypes.number,
  visible: PropTypes.bool,
  rol: PropTypes.string,
  enterpriseId: PropTypes.number,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
};

export default InviteUser;
